@if (account && (defaultActivity$$ | async) && activityForm) {
  <div [formGroup]="activityForm" class="content">
    <h2 class="content-header" translate="account-settings-panel_assignment-defaults"></h2>
    <div goRequiredFieldsNote></div>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label translate="default-activity-settings_activity-type-select-label"></mat-label>
      <mat-select
        formControlName="template"
        (selectionChange)="onActivityValueChanged()"
        disableOptionCentering
        panelClass="offsetPanel">
        <mat-select-trigger>
          {{activityForm.controls.template.value.type}}
        </mat-select-trigger>
        @for (template of activityTemplates; track template) {
          <mat-option class="activity-settings-option"
            [value]="template"
            >
            <span class="option-title">{{template.type}}</span>
            <p>{{template.description}}</p>
          </mat-option>
        }
        <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
      </mat-select>
      @if (activityForm.controls.template.hasError('required')) {
        <mat-error
          translate="common_required_field">
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label translate="default-activity-settings_privacy-type-select-label"></mat-label>
      <mat-select
        #privacySelect
        formControlName="privacyType"
        disableOptionCentering
        panelClass="offsetPanel">
        <mat-select-trigger [translate]="activityForm.controls.privacyType.value?.title">
        </mat-select-trigger>
        @for (privacy of privacyTypes; track privacy) {
          <mat-option class="activity-settings-option"
            [value]="privacy">
            <span class="option-title" [translate]="privacy.title"></span>
            <p [translate]="privacy.description"></p>
          </mat-option>
        }
      </mat-select>
      @if (activityForm.controls.privacyType.hasError('required')) {
        <mat-error>
          {{ 'common_required-field-with-name' | translate: { fieldName: ('default-activity-settings_privacy-type-select-label' | translate) } }}
        </mat-error>
      }
      <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
    </mat-form-field>
    <!-- AI Markers -->
    @if (isAiCompatible()) {
      <section
        class="form-group ai-markers-group">
        @if (!selectedAiUseType) {
          <section>
            <button
              type="button"
              [attr.aria-label]="'default-ai-marker-aria-label' | translate"
              class="link-btn add-btn ai-markers-btn"
              translate="default-ai-marker-title"
              (click)="openAiMarkerSelectionModal()">
            </button>
          </section>
        }
        @if (selectedAiUseType) {
          <ai-marker-set-panel
            class="ai-markers-set"
            [llmDefinitions]="defaultLlmDefinitions"
            [title]="selectedAiUseTypeName"
            [canPreview]="false"
            (onEdit)="openAiMarkerSelectionModal('edit')"
            (onRemove)="handleAiMarkerSetRemove()"
            >
          </ai-marker-set-panel>
        }
      </section>
    }
    <!-- Markers -->
    <section
      class="form-group markers-group">
      @if (!selectedMarkerSet) {
        <section>
          <button
            type="button"
            aria-label="marker set add"
            class="link-btn add-btn markers-btn"
            translate="activity-editor-new_markers"
            (click)="openMarkerSelectionModal()">
          </button>
        </section>
      }
      @if (selectedMarkerSet) {
        <marker-set-panel
          class="tagset-section"
          [markerSet]="selectedMarkerSet"
          [activity]="defaultActivity$$.getValue()"
          (onEdited)="handleMarkerSetEdited($event)"
          (onRemoved)="handleMarkerSetRemoved()">
        </marker-set-panel>
      }
    </section>
    <mat-slide-toggle
      color="primary"
      [hideIcon]="false"
      formControlName="is_feedback_published">
      {{'activity-list_activity-options-menu-publish-feedback-and-grades' | translate}}
    </mat-slide-toggle>
  </div>
}

@if (showSaveButton$ | async) {
  <div class="content-footer">
    <button	(click)="save()"
      [disabled]="this.isSaving$ | async"
      class="primary-btn submit-btn"
      type="submit"
      translate="common_save-changes">
    </button>
  </div>
}
